namespace GeniuzPOS.QRreport {
    export class QRyreportColumns {
        static columnsKey = 'QRreport.QRyreport';
    }
}
